export default "__VITE_ASSET__BUaMkR5d__"